module.exports = __webpack_public_path__ + "img/Electronic2.3ae32c57.png";